import { render, staticRenderFns } from "./OrderAccountListMobile.vue?vue&type=template&id=21bbd17a&scoped=true&"
import script from "./OrderAccountListMobile.vue?vue&type=script&lang=js&"
export * from "./OrderAccountListMobile.vue?vue&type=script&lang=js&"
import style0 from "./OrderAccountListMobile.vue?vue&type=style&index=0&id=21bbd17a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21bbd17a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VPagination } from 'vuetify/lib/components/VPagination';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCol,VPagination,VRow})
